import { styled, Typography } from '@mui/material';

export const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: 24,
  fontWeight: 700,
  alignItems: 'left',
  marginBottom: theme.spacing(0.5),
  color: theme.palette.grey[50],
}));

export const StyledDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[400],
}));
StyledDescription.defaultProps = {
  variant: 'body1',
};
